@if (isInitialized) {
  <oe-flat-widget [title]="'GENERAL.CONSUMPTION' | translate" [icon]="{name: 'oe-consumption', color: 'warning'}" button
    [link]="'/device/' + edge.id + newNavigationUrlSegment + '/history/consumptionchart'">
    @if (evcsComponents.length === 0 && consumptionMeterComponents.length === 0 && heatComponents.length === 0) {
      @if (hasGridMeter) {
        <oe-flat-widget-line channelAddress="_sum/ConsumptionActiveEnergy"
          [converter]="Utils.CONVERT_TO_KILO_WATTHOURS"></oe-flat-widget-line>
      }
    } @else {
      @for (evcs of evcsComponents; track evcs) {
        <oe-flat-widget-line [name]="evcs.alias" [channelAddress]="evcs.energyChannel.toString()"
          [converter]="Utils.CONVERT_TO_KILO_WATTHOURS"></oe-flat-widget-line>
      }
      @for (component of heatComponents; track component) {
        <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.HEAT.HEATING_ENERGY' | translate"
          [channelAddress]="component.id + '/ActiveProductionEnergy'"
          [converter]="Utils.CONVERT_TO_KILO_WATTHOURS"></oe-flat-widget-line>
      }
      @for (component of consumptionMeterComponents; track component) {
        <oe-flat-widget-line [name]="component.alias" [channelAddress]="component.id + '/ActiveProductionEnergy'"
          [converter]="Utils.CONVERT_TO_KILO_WATTHOURS"></oe-flat-widget-line>
      }
    }
    @if ((evcsComponents.length !== 0 || consumptionMeterComponents.length !== 0 || heatComponents.length !== 0)) {
      <oe-flat-widget-horizontal-line></oe-flat-widget-horizontal-line>
      <oe-flat-widget-line [name]="'GENERAL.OTHER_CONSUMPTION'| translate" [value]="totalOtherEnergy"
        [converter]="Utils.CONVERT_TO_KILO_WATTHOURS">
      </oe-flat-widget-line>
    }
  </oe-flat-widget>
}
